import ComponontFactory from '../../../shared/utils/ComponentFactory';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import styles from './Confirmation.less';
import Modal from '../../../shared/components/Modal/Modal';
import DetailsForm from './DetailsForm/DetailsForm';
import ErrorMessage from './ErrorMessage/ErrorMessage';
import SmsMessage from './SmsMessage/SmsMessage';
import Success from './Success/Success';
import { actions as sessionActions } from '../../../actions/SessionActions';
import { actions as formActions } from '../../../actions/FormActions';
import { actions as settingsActions } from '../../../actions/SettingsActions';

export default ComponontFactory({
        propTypes: {
            restaurant: PropTypes.object,
            form: PropTypes.object,
            errors: PropTypes.object,
            session: PropTypes.object,
            settings: PropTypes.object,
            onClose: PropTypes.func.isRequired,
            onSubmit: PropTypes.func.isRequired,
            onDone: PropTypes.func.isRequired,
            onValidate: PropTypes.func.isRequired,
            onUpdate: PropTypes.func.isRequired,
            onPublish: PropTypes.func.isRequired,
            isCustomDesign: PropTypes.bool,
            preview: PropTypes.bool,
            compId: PropTypes.string,
            isSendingReservation: PropTypes.bool
        },

        getInitialState() {
            return {
                editDetails: false,
                editRequests: !!this.props.form.reservation.requests,
                isClosing: false
            };
        },

        componentWillUpdate(nextProps) {
            if (nextProps.form.reservation.requests && !this.state.editRequests) {
                this.setState({editRequests: true});
            }
        },

        componentDidUpdate({ session: prevSession }) {
            const { session } = this.props;

            if (typeof document !== 'undefined' && session.step !== prevSession.step) {
                document.getElementById('modal-content').scrollTop = 0;
            }
        },

        render() {
            const { isCustomDesign, preview,restaurant } = this.props;
            const content = this._getContent();

            return (
                <Modal onClose={this._closePopup} isPreview={preview} restaurant={restaurant}
                       isCustomDesign={isCustomDesign}
                       className={styles.modal}
                       closeButtonRef={el => this.modalCloseButton = el}
                       onCloseShiftFocus={this._confirmButtonFocus}
                       marginTop={preview ? -48 : 0}>
                    <div id="modal-content" className={`${styles.stage} ${isCustomDesign ? styles.custom : ''} ${preview ? styles.preview : ''}`}>{content}</div>
                </Modal>
            );
        },

        _confirmButtonFocus() {
            if (this.doneButtonElem) {
                this.doneButtonElem.focus();
            }
        },

        _getContentRef(el) {
            this.confirmationContent = el;
        },

        _doneButtonElemRef(el) {
            this.doneButtonElem = el;
        },

        _focusCloseButton() {
            this.modalCloseButton.focus();
        },

        _getContent() {
            const { session } = this.props;
            const { reserveResponse, errorResponse, step, stepOptions } = session;
            let reservation = reserveResponse || {};
            let content = null;

            switch (step) {
                case stepOptions.FORM:
                    content = this._getFormContent();
                    break;
                case stepOptions.SUCCESS:
                    content = this._getSuccessContent(reservation);
                    break;
                case stepOptions.SMS_VALIDATION:
                    content = this._getValidationContent(reservation.contact.phone);
                    break;
                case stepOptions.ERROR:
                    content = this._getErrorContent(errorResponse);
                    break;
            }

            return content;
        },

        _getFormContent() {
            const { isClosing } = this.state;
            const { form, errors, settings, preview, restaurant, compId, isSendingReservation } = this.props;
            const { isCustomDesign } = settings;

            return (
                <DetailsForm onSubmit={this._onSubmit}
                             compId={compId}
                             restaurant={restaurant}
                             settings={settings}
                             onUpdate={this._onUpdate}
                             isCustomDesign={isCustomDesign}
                             form={form}
                             errors={errors}
                             preview={preview}
                             onPremiumClick={this._onPremiumClick}
                             refreshUniqueId={Math.random()}
                             isClosing={isClosing}
                             doneButtonRef={this._doneButtonElemRef}
                             onButtonBlur={this._focusCloseButton}
                             isSendingReservation={isSendingReservation}
                             sessionActions={this.props.sessionActions}
                             session={this.props.session}
                />
            );
        },

        _getErrorContent(reservation) {
            const { isCustomDesign } = this.props.settings;
            return (
                <ErrorMessage response={reservation}
                              doneButtonRef={this._doneButtonElemRef}
                              onButtonBlur={this._focusCloseButton}
                              onConfirm={this._onBack}
                              isCustomDesign={isCustomDesign}/>
            );
        },

        _getValidationContent(phone) {
            const { restaurant, session, settings } = this.props;
            const { isCustomDesign } = settings;
            const { errorResponse } = session;
            let status = _.isEmpty(errorResponse) ? 'idle' : 'error';

            return (
                <SmsMessage refreshUniqueId={Math.random()}
                            doneButtonRef={this._doneButtonElemRef}
                            onButtonBlur={this._focusCloseButton}
                            phone={phone}
                            countryCode={restaurant.address.countryCode}
                            onSubmit={this._onSmsValidation}
                            onBack={this._onBack}
                            isCustomDesign={isCustomDesign}
                            status={status}/>
            );
        },

        _getSuccessContent(reservation) {
            const { restaurant, settings, onDone, form, preview } = this.props;
            const { isCustomDesign } = settings;
            return (
                <Success reservation={reservation}
                         doneButtonRef={this._doneButtonElemRef}
                         onButtonBlur={this._focusCloseButton}
                         onConfirm={onDone}
                         isCustomDesign={isCustomDesign}
                         restaurant={restaurant}
                         form={form}
                         preview={preview}
                         gotoDashboard={this._gotoDashboard}
                         onPremiumClick={this._onPremiumClick}/>
            );
        },

        _onPremiumClick() {
            const { onPublish } = this.props;
            onPublish({type: 'upgrade'});
        },

        _gotoDashboard() {
            const { onPublish } = this.props;
            onPublish({type: 'dashboard'});
        },

        _onSubmit() {
            const { onSubmit, form } = this.props;
            const { reservation, errors, options } = form;
            onSubmit && onSubmit({reservation, errors, options});
        },

        _closePopup() {
            this.setState({isClosing: true}, () => {
                setTimeout(this.props.onClose, 300);
            });
        },

        _onUpdate({value, type}) {
            const { formActions, onUpdate } = this.props;
            formActions.updateField({value, type});
            onUpdate({value, type});
        },

        _onSmsValidation(code) {
            this.props.onValidate({code});
        },

        _onBack() {
            this.props.onBack();
        }
    }, state => ({form: state.seatingForm, session: state.seatingSession, settings: state.seatingSettings}),
    {formActions, sessionActions, settingsActions});
